module.exports = __webpack_public_path__ + "img/ag_gallery_2.40d52439.jpg";